<template>
  <!-- 动态选择弹窗类型 -->
  <component :is="isMobile ? 'el-drawer' : 'el-dialog'" :visible.sync="dialogVisible"
    :direction="isMobile ? 'btt' : undefined" :width="isMobile ? undefined : '25%'" :before-close="handleClose"
    custom-class="popStyle" :lock-scroll="true" :top="isMobile ? undefined : '25vh'" :show-close="false">
    <!-- 弹窗标题 -->
    <div slot="title">
      <div class="popStyle_title">
        {{ $t(baseInfo.title) }}
      </div>
      <div>
        <img class="popStyle_close" @click="handleClose" src="@/assets/images/close.png" alt="" />
      </div>
    </div>
    <div class="popStyle_scroll">
      <div :class="isMobile ? 'popStyle_intro_border' : ''">
        <div>
          <div class="popStyle_intro">
            <div v-if="pageType != 4">
              {{
                pageType === 2
                  ? $t("认购数量")
                  : pageType === 1
                    ? $t("预约认购数量")
                    : pageType === 3
                      ? $t("提取数量")
                      : ""
              }}
            </div>

            <div v-if="pageType == 2">
              {{ $t("限购") + maxNum + $t("个") }}
            </div>
          </div>
          <el-input-number v-if="popType == 1" class="popStyle_num" v-model="num" @change="handleChange" :min="1"
            :max="maxNum" />
        </div>

        <div v-if="popType == 2" class="popStyle_inp">
          <el-input v-model="textValue" :placeholder="$t(textPlace)"></el-input>
        </div>
        <div v-if="pageType == 3" class="popStyle_allnum ml-0 mb-0">
          可提取数量: <span>{{ allNum | formatThous }}</span>
        </div>
      </div>
    </div>
    <!-- 弹窗内容 -->

    <!-- 弹窗底部按钮 -->
    <div :class="isMobile ? 'drawer-footer' : 'dialog-footer'">
      <div class="dialog-footer_sty" style="display: flex;align-items: center;justify-content: flex-end;">
        <div class="dialog-footer_money mb-1" v-if="pageType == 2">
          <div>{{ $t("总价") }}{{ comNum | formatThous }} USDT</div>
        </div>


      </div>
      <div style="text-align: center;">
        <el-button type="primary" @click="handleSubmit">
          {{ $t(baseInfo.btnTitle) }}
          <!-- {{ pageType === 2 ? $t("确认认购") : $t("确认预约") }} -->
        </el-button>
      </div>
    </div>
  </component>
</template>
<script>
export default {
  name: "Popup",
  props: {
    popType: {
      type: Number,
      default: 1,
    }, //1步进器，2输入框
    allNum: {
      type: Number,
      default: 0,
    }, //可提取数量
    textPlace: {
      type: String,
      default: "请输入",
    }, //输入框placeholder文字
    pageType: { type: Number, default: 1 }, // 1=预约, 2=认购,4=社区名称
    dialogVisible: { type: Boolean, default: false }, // 控制弹窗显示
    maxNum: { type: [Number, String], default: 100 }, // 最大购买数量
    totalPrice: { type: Number, default: 132454 }, // 总价
    baseInfo: {
      type: Object,
      default: {
        title: "预约认购",
        btnTitle: "确认预约",
      },
    },
  },
  data() {
    return {
      num: 1, // 默认数量
      textValue: null, //输入框默认值
      isMobile: false, // 是否移动端
    };
  },
  computed: {
    comNum() {
      return this.num ? this.totalPrice * this.num : 0;
    },
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        // 弹窗打开时：禁止滚动
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      } else {
        // 弹窗关闭时：恢复滚动
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
        this.num = 1;
        this.textValue = null;
      }
    },
  },
  mounted() {
    // 检测是否是移动端
    this.checkIsMobile();
    window.addEventListener("resize", this.checkIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIsMobile);
  },
  methods: {
    // 判断设备类型
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    // 关闭弹窗
    handleClose(done) {
      this.$emit("handleClose");
    },
    // 提交表单
    handleSubmit() {
      if (this.popType == 1) {
        this.$emit("submit", this.num);
      } else if (this.popType == 2) {
        this.$emit("submit", this.textValue);
      }
    },
    // 数量变化回调
    handleChange(value) {
      this.num = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.popStyle_inp {
  padding: 0.5rem;
  margin-bottom: 1rem;

  ::v-deep .el-input__inner {
    background: #ffffff;
    border-radius: 0.2rem;
    border: 1px solid #F2F4F6 !important;

    .el-input__inner::placeholder {
      color: #555555 !important;
      opacity: 1;
    }
  }
}

.popStyle_scroll {
  height: calc(100% - 70px);
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.popStyle_allnum {
  font-size: 0.7rem;
  color: #7e8190;
  margin-top: -1rem;

  span {
    color: #ff6200;
  }
}
</style>